import React from "react";

import { FlickLogo } from "./FlickLogo";

export const Header = () => {
  return (
    <div className="page_banner_wrapper background_pattern_bolt page_banner_wrapper--delta">
      <div id="header">
        <div className="header">
          <a href="https://www.flickelectric.co.nz" className="header_logo">
            <FlickLogo />
          </a>
        </div>
      </div>
      <div className="page_banner">Let's get you signed up</div>
    </div>
  );
};

export default Header;
